import { render, staticRenderFns } from "./Gender.vue?vue&type=template&id=3647a162&scoped=true"
import script from "./Gender.vue?vue&type=script&lang=js"
export * from "./Gender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3647a162",
  null
  
)

export default component.exports